<section>
    <app-transcriptions-filter (filterEmmiter)="setFilter($event)"></app-transcriptions-filter>
    <app-transcription-list [filter]="filter"></app-transcription-list>
  </section>  